/* eslint-disable react/prop-types */

import React, { useState } from 'react';

import GoogleMapReact from 'google-map-react'
import { Wrapper } from "./styles";
import { Marker } from 'components/MapMarker'
import {useApp} from "../../contexts/AppContext";

const Map = ({params, selected = {}, boxHotel = true}) => {

    const COORDS_DEFAULT = params ? params : { lat: -25.4284, lng: -49.2733 }

    const { hotelState } = useApp();
    const { hotelsList } = hotelState;

    const [places, setPlaces] = useState(hotelsList)
    const [coords, setCoords] = useState(COORDS_DEFAULT);
    const [placeSelected, setPlaceSelected] = useState(selected)

    const onChildClickCallback = (key) => {
        const newPlace = [...places]
        let place = newPlace[key]

        setCoords({
            lat: JSON.parse(place.address.latitude),
            lng: JSON.parse(place.address.longitude)
        })

        place.show = !place.show
        setPlaceSelected(place)
        setPlaces(newPlace)
    };

    if (!places || places.length === 0) {
        return null;
    }

    return (
        <Wrapper size={!boxHotel ? boxHotel : 'small'}>
            <GoogleMapReact
                defaultZoom={!boxHotel ? 18 : 14}
                defaultCenter={COORDS_DEFAULT}
                center={coords}
                bootstrapURLKeys={{ key: "AIzaSyA9KYgsQR_FoMhg2peRey-o-ioKhH8UY_M" }}
                options={{ disableDefaultUI: true, zoomControl: false }}
                onChildClick={onChildClickCallback}
                onChange={(e) => {
                    //setCoords({ lat: e.center.lat, lng: e.center.lng });
                   // setBounds({ ne: e.marginBounds.ne, sw: e.marginBounds.sw });
                }}
            >
                { places.map((place, index) => (
                    <Marker
                        key={index}
                        text={place.name}
                        lat={JSON.parse(place.address?.latitude)}
                        lng={JSON.parse(place.address?.longitude)}
                        show={placeSelected.name === place.name}
                        place={place}
                        setPlaceSelected={setPlaceSelected}
                        id={index}
                        boxHotel={boxHotel}
                    />
                ))}
            </GoogleMapReact>
        </Wrapper>
    )
}

export default Map
